import { FC, useState } from 'react';

import { CurrentCity, useCurrentUserCity } from '@hooks/useCurrentUserLocation';

import Button from '@components/buttons/Button';
import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';
import { Picker } from '@components/layout/Picker/Picker';
import { PopoverWrapper } from '@components/layout/Popover/PopoverWrapper';

const CityLabel = ({ city, onClick }: { city?: CurrentCity; onClick?: () => void }) => {
  if (!city) {
    return <></>;
  }

  return (
    <div className="d-flex gap-2 align-items-center" onClick={onClick}>
      <FontAwesomeIcon name="map-marker-alt" />
      <span>{city.name}</span>
      <FontAwesomeIcon name="chevron-down" />
    </div>
  );
};

const SingleCityPicker: FC = () => {
  const { currentCity } = useCurrentUserCity();

  return (
    <PopoverWrapper
      PopoverContent={({ onClose }) => (
        <div className="p-4">
          <p className="mt-0 mb-1">
            <strong>We're still in beta!</strong>
          </p>
          <p className="mt-0 mb-3">
            We currently only support events based on your current location. But stay tuned, we'll
            start allowing you to explore other cities shortly!
          </p>
          <Button variant="outlined" color="neutral" onClick={onClose}>
            Got it, Thanks!
          </Button>
        </div>
      )}
    >
      <CityLabel city={currentCity} />
    </PopoverWrapper>
  );
};

const MultiCityPicker: FC = () => {
  const [updatedCity, setUpdatedCity] = useState<CurrentCity>();
  const { currentCity, cities } = useCurrentUserCity();

  const [cityPickerIsVisible, setCityPickerIsVisible] = useState(false);

  return (
    <>
      <CityLabel city={updatedCity ?? currentCity} onClick={() => setCityPickerIsVisible(true)} />
      {currentCity && cities?.length && (
        <Picker
          isVisible={cityPickerIsVisible}
          onClose={() => setCityPickerIsVisible(false)}
          value={currentCity?._id}
          onChange={(updatedCityId) => {
            console.log(`City changed to: ${updatedCityId}`);
            setUpdatedCity(cities.find(({ _id }) => _id === updatedCityId));
          }}
          options={cities.map((city) => ({
            value: city._id,
            label: city.name,
          }))}
        />
      )}
    </>
  );
};

export const CityPicker: FC = () => {
  const { multiCityEnabled } = useCurrentUserCity();
  return multiCityEnabled ? <MultiCityPicker /> : <SingleCityPicker />;
};
